import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import { API_URL } from "../../../config";
import InvoiceBody from "./invoice_body";
import PrintIcon from "@material-ui/icons/Print";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import BookIcon from '@material-ui/icons/Book'
import DescriptionIcon from "@material-ui/icons/Description";
import { Link } from 'react-router-dom';
import Button from "@material-ui/core/Button";
import moment from "moment";
import ReactToPrint from "react-to-print";
import "./invoice.css";
import commaNumber from "comma-number";
import { convertNumberToWords } from "../../../lib/functions.js"
let format = commaNumber.bindWith(",", ".");

class PrintAbleSection extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    sale: [],
    loading: true,
    error: "",
  };

  componentDidMount() {
    this.getsale();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.saleId != this.props.saleId) {
      this.getsale();
    }
  }

  getsale = async () => {
    if (!this.props.saleId || Number.isNaN(Number(this.props.saleId))) {
      this.setState({ sale: [], loading: false, error: "Invalid invoice id." });
      return;
    }

    this.setState({ loading: true, error: "" });
    await axios
      .post(
        `${API_URL}/api/get-sales-with-details`,
        { reqPayload: { saleId: this.props.saleId, from: "invoice" } },
        { headers: { "auth-token": this.props.authInfo.token } }
      )
      .then((res) => {
        const rows = Array.isArray(res?.data?.message) ? res.data.message : [];

        if (rows.length == 0) {
          this.setState({ sale: [], loading: false, error: `Invoice not found for sale id ${this.props.saleId}.` });
          return false;
        }

        this.setState({ sale: rows[0], loading: false, error: "" });
      })
      .catch((error) => {
        this.setState({
          sale: [],
          loading: false,
          error: error?.response?.data?.message || error?.message || "Invoice load failed.",
        });
      });
  };

  render() {
    let { sale } = this.state;
    const institution = this.props.institution
    return (
      <div style={{ padding: "10px" }}>
        {this.state.loading ? (
          <p>Loading invoice...</p>
        ) : this.state.error ? (
          <Paper style={{ padding: "12px", color: "#b00020" }}>{this.state.error}</Paper>
        ) : sale && Object.keys(sale).length != 0 ? (
          <>
            <Grid container style={{ marginBottom: "30px", fontSize: "13px" }}>
              <Grid item xs={6} sm={8}>
                <strong>Customer ID : </strong>{" "}
                <span>{sale.customer_code}</span>
                <br />
                <strong>Customer Name : </strong>{" "}
                <span>{sale.customer_name}</span>
                <br />
                <strong>Unit Name : </strong>{" "}
                <span>{sale.customer_institution_name}</span>
                <br />
                <strong>Customer Address : </strong>{" "}
                <span>{sale.customer_address}</span>
                <br />
                <strong>Customer Mobile : </strong>{" "}
                <span>{sale.customer_mobile_no}</span>
                <br />
                <strong>PO No : </strong> <span>{sale.sale_po_id}</span>
                <br />
              </Grid>
              <Grid item xs={6} sm={4} style={{ textAlign: "left" }}>
                <strong>Sale By : </strong> <span style={{ textTransform: "uppercase" }}>{institution?.pro_name || "784"}</span>
                <br />
                <strong>Ref By : </strong> <span style={{ textTransform: "uppercase" }}>{sale.employee_name}</span>
                <br />
                <strong>Invoice No : </strong> <span>{sale.sale_invoice}</span>
                <br />

                <strong>Sale Date : </strong>{" "}
                <span>
                  {moment(sale.sale_created_isodt).format("DD MMM Y")}
                </span>
                <br />
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} sm={12}>
                <h3 className={"invoice-title"}>Sales Invoice</h3>
              </Grid>
            </Grid>

            <InvoiceBody
              saleData={sale}
              hideCountry={this.props.print && this.props.hideCountryInPrint}
              showCountryPrintToggle={!this.props.print}
              hideCountryInPrint={this.props.hideCountryInPrint}
              onHideCountryInPrintChange={this.props.onHideCountryInPrintChange}
            />

            <Grid container>
              <Grid item xs={12} sm={6} style={{ marginTop: "2px", marginLeft: "auto" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>Sub Total : </td>
                    <td style={{ textAlign: "right" }}>
                      {" "}
                      {format(
                        parseFloat(sale.sale_subtotal_amount).toFixed(2)
                      )}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>Transport Cost : </td>
                    <td style={{ textAlign: "right" }}>
                      {" "}
                      {format(
                        parseFloat(sale.sale_transport_cost).toFixed(2)
                      )}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>AIT :</td>
                    <td style={{ textAlign: "right" }}>
                      {" "}
                      {format(parseFloat(sale.sale_ait_amount).toFixed(2))}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>Vat :</td>
                    <td style={{ textAlign: "right" }}>
                      {" "}
                      {format(parseFloat(sale.sale_vat_amount).toFixed(2))}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>Discount :</td>
                    <td style={{ textAlign: "right" }}>
                      {" "}
                      {format(
                        parseFloat(sale.sale_discount_amount).toFixed(2)
                      )}{" "}
                    </td>
                  </tr>

                  <tr>
                    <td
                      style={{
                        background: "#ccc",
                        textAlign: "right",
                        width: "100%",
                      }}
                    ></td>
                    <td
                      style={{
                        background: "#ccc",
                        textAlign: "right",
                        width: "100%",
                      }}
                    ></td>
                  </tr>
                  <tr>
                    <td>Total : </td>
                    <td style={{ textAlign: "right" }}>
                      {" "}
                      {format(
                        parseFloat(sale.sale_total_amount).toFixed(2)
                      )}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>Paid : </td>
                    <td style={{ textAlign: "right" }}>
                      {" "}
                      {format(
                        parseFloat(sale.sale_paid_amount).toFixed(2)
                      )}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        background: "#ccc",
                        textAlign: "right",
                        width: "100%",
                      }}
                    ></td>
                    <td
                      style={{
                        background: "#ccc",
                        textAlign: "right",
                        width: "100%",
                      }}
                    ></td>
                  </tr>
                  <tr>
                    <td>Due : </td>
                    <td style={{ textAlign: "right" }}>
                      {" "}
                      {format(parseFloat(sale.sale_due_amount).toFixed(2))}
                    </td>
                  </tr>
                </table>
              </Grid>

              <Grid xs={12} sm={12}>
                <p>
                  In Word : {convertNumberToWords(sale.sale_total_amount)}{" only"}
                </p>
                <p>Note : {sale.sale_note}</p>
              </Grid>

              {!this.props.print && (
                <Grid item xs={12} style={{ textAlign: "right", marginTop: "20px" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      // Using state instead of window.location for SPA navigation (no reload)
                      this.props.history.push({
                        pathname: "/sales/sales-entry",
                        state: {
                          quotationData: sale,
                          fromQuotation: true
                        }
                      });
                    }}
                  >
                    Return to Sales Entry
                  </Button>
                </Grid>
              )}
            </Grid>
          </>
        ) : (
          ""
        )}
      </div>
    );
  }
}

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    authInfo: this.props.authInfo,
    saleId: this.props.saleId,
  };

  render() {
    let institution = this.props.institution;
    let a4css = `
    .a4 {
      font-size: 14px;
      
  }
  .a4 body, table{
      font-size: 14px;
  }
    `;

    let hafa4css = `
    .hafa4 { 
      width:500px !important;
  }
  .hafa4 body, table{
      font-size: 14px;
  }
    `;

    let poscss = `
     body{
      font-size: 12px;
      font-weight: bold;
      font-family: cursive;
  }
   body, table{
      font-size: 12px;
      font-weight: bold;
  }

  .pos  table{
    font-size: 12px;
    font-weight: bold;
}
    `;

    return (
      <div className="print-source">
        {/* Print  DOCUMENT */}

        {
          /* {   A4 Print */
          institution != null && institution.pro_print_type == "a4" ? (
            <html lang="en">
              <body
                className="a4"
                style={{
                  paddingTop: "21mm",
                  paddingBottom: "0mm",
                  paddingLeft: "5mm",
                  paddingRight: "5mm",
                  position: "relative",
                }}
              >
                <PrintAbleSection
                  authInfo={this.state.authInfo}
                  saleId={this.props.saleId}
                  institution={institution}
                  print={true}
                  hideCountryInPrint={this.props.hideCountryInPrint}
                />

                <div
                  style={{
                    position: "fixed",
                    bottom: "0mm", // safe printable bottom
                    left: "5mm",    // align with page padding
                    right: "5mm",
                  }}
                >
                  {/* <div
                    className="invoice-footer-bottom"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      fontSize: "12px",
                    }}
                  >
                    <p>
                      Print Date & Time: {moment(currentDateTime()).format(dateTimeFormat)}
                    </p>
                    <p>Developed By: DeshIT-BD | Contact No = 01813320587</p>
                  </div> */}
                </div>
              </body>
            </html>
          ) : (
            ""
          )
        }

        {
          /* {  1/2 - A4   Print */
          institution != null && institution.pro_print_type == "1/2a4" ? (
            <html lang="en">
              <body className="hafa4" style={{ padding: "5px" }}>
                <div className="invoice-head" style={{ width: "500px" }}>
                  <div
                    className="invoice-desc"
                    style={{ width: "75%", float: "right", marginLeft: "1%" }}
                  ></div>
                </div>

                <PrintAbleSection
                  authInfo={this.state.authInfo}
                  saleId={this.props.saleId}
                  institution={institution}
                  print={true}
                  hideCountryInPrint={this.props.hideCountryInPrint}
                />
                {/* <div
                  style={{
                    marginTop: "150px",
                    bottom: "0px",
                    width: "500px",
                    padding: "5px",
                  }}
                >
                  <div className="invoice-footer">
                    <p
                      style={{
                        float: "left",
                        borderTop: "1px solid #222",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      Received By
                    </p>

                    <p
                      style={{
                        float: "right",
                        marginRight: "10px",
                        borderTop: "1px solid #222",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      Authorized By
                    </p>
                  </div>
                  <div
                    className="invoice-footer-bottom"
                    style={{ width: "500px" }}
                  >
                    <p style={{ float: "left" }}>
                      Print Date & Time :{" "}
                      {moment(currentDateTime()).format(dateTimeFormat)}
                    </p>
                    <p style={{ float: "left", marginRight: "10px" }}>
                      Developed By : DeshIT-BD | Contact No = 01813320587
                    </p>
                  </div>
                </div> */}
              </body>
            </html>
          ) : (
            ""
          )
        }

        {
          /* {   Pos Print */
          institution != null && institution.pro_print_type == "pos" ? (
            <html lang="en">
              <body
                className="pos"
                style={{ padding: "5px", width: "302.36px" }}
              >
                <div
                  className="invoice-head"
                  style={{
                    width: "302.36px",
                    float: "left",
                    marginLeft: "1px",
                    marginTop: "20px",
                  }}
                >
                  <div
                    className="invoice-desc"
                    style={{
                      width: "230px",
                      float: "right",
                      marginLeft: "1px",
                    }}
                  ></div>
                </div>

                <PrintAbleSection
                  authInfo={this.state.authInfo}
                  saleId={this.props.saleId}
                  institution={institution}
                  print={true}
                  hideCountryInPrint={this.props.hideCountryInPrint}
                />
                {/* <div
                  style={{
                    marginTop: "150px",
                    bottom: "0px",
                    width: "100%",
                    padding: "5px",
                  }}
                >
                  <div className="invoice-footer-bottom">
                    <p style={{ float: "left" }}>
                      Print Date & Time :{" "}
                      {moment(currentDateTime()).format(dateTimeFormat)}
                    </p>
                    <p style={{ float: "right", marginRight: "10px" }}>
                      Developed By : DeshIT-BD | Contact No = 01813320587
                    </p>
                  </div>
                </div> */}
              </body>
            </html>
          ) : (
            ""
          )
        }
      </div>
    );
  }
}

let SalesInvoice = ({ authInfo, saleId, institution, history }) => {
  let componentRef = useRef();
  const [hideCountryInPrint, setHideCountryInPrint] = useState(false);

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={8} className={"invoice-section"}>
          {/* Main Grid Start */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
            <ReactToPrint
              trigger={() => (
                <Button size="small" variant="outlined" startIcon={<PrintIcon />}>
                  Print
                </Button>
              )}
              content={() => componentRef}
            />
            <Link to={`/sales/chalan-invoice/${saleId}`}>
              <Button size="small" variant="outlined" startIcon={<BookIcon />}>
                Chalan
              </Button>
            </Link>
            <Link to={`/administration/delivery-info/${saleId}`}>
              <Button size="small" variant="outlined" startIcon={<LocalShippingIcon />}>
                Delivery
              </Button>
            </Link>
            <Link to={`/sales/mushak63-invoice/${saleId}`} title="Mushak 6.3 Experimental">
              <Button size="small" variant="outlined" startIcon={<DescriptionIcon />}>
                Mushak 6.3
              </Button>
            </Link>
          </div>

          <ComponentToPrint
            ref={(el) => (componentRef = el)}
            authInfo={authInfo}
            saleId={saleId}
            institution={institution}
            hideCountryInPrint={hideCountryInPrint}
          />

          <PrintAbleSection
            authInfo={authInfo}
            saleId={saleId}
            institution={institution}
            history={history}
            print={false}
            hideCountryInPrint={hideCountryInPrint}
            onHideCountryInPrintChange={setHideCountryInPrint}
          />
        </Grid>
      </Grid>
    </>
  );
};

const mapStateToPops = (state) => {
  return {
    authInfo: state.authInfoReducer,
  };
};
export default connect(mapStateToPops, {})(SalesInvoice);
